import ShopaholicProductList from '@lovata/shopaholic-product-list/shopaholic-product-list';
import ShopaholicFilterPanel from '@lovata/shopaholic-filter-panel/shopaholic-filter-panel';
import LazyLoad from '../../../../js/lazy-load';
import Select from '../../../form/select/select';
import ProductCardAddCart from '../../product-card/product-card-add-cart';

export default new class FilterPanel {
  constructor() {
    this.sCatalogWrapper = 'catalog__wrapper';
    this.preLoaderSelector = '.catalog__preloader';
    this.filterPreLoaderElector = '.filter__preloader';
    this.filterWrapperPreLoaderElector = '.filter-wrapper__preloader';
    this.brandWrapperSelector = '._shopaholic-brand-filter-wrapper';
    this.newFilterWrapper = '._new-filter-wrapper';
    this.hitFilterWrapper = '._hit-filter-wrapper';
    this.saleFilterWrapper = '._sale-filter-wrapper';
    this.discountFilerWrapper = '._discount-filter-wrapper';
    this.filterBtnWrapperSelector = '.filter-bar__filter-btn-wrapper';
    this.filterPanelWrapper = '.filter__wrapper';
    this.filterBarSelector = '.filter-bar';

    this.sOpenCategorySelector = '_js-open-category';
    this.categoryDataIDSelector = 'data-category-id';

    this.arCategoryData = [];

    this.mediaQueryList = window.matchMedia('(min-width: 769px)');
    this.handlers();
  }

  handlers() {
    if (!document.querySelector(`.${this.sCatalogWrapper}`)) return;

    this.initFilterHandlers();
    this.openCategoryLink();

    document.addEventListener('DOMContentLoaded', () => {
      this.chooseAjaxHelper();
    });
  }

  openCategoryLink() {
    $(document)
      .on('click', `.${this.sOpenCategorySelector}`, (e) => {
        e.preventDefault();
        const categoryId = e.currentTarget.getAttribute(this.categoryDataIDSelector);

        $.request('Catalog::onGetCategoryData', {
          data: {
            categoryId,
          },
          update: {
            'product/catalog/catalog-ajax': `.${this.sCatalogWrapper}`,
          },
          loading: this.preLoaderSelector,
          success(res) {
            this.success(res);
            ProductCardAddCart.initCartFooter();
            LazyLoad.update();
            // eslint-disable-next-line no-restricted-globals
            history.pushState(null, null, res.data.page_url);
            document.title = res.data.seo_title;
          },
        });
      });
  }

  isDesktop() {
    return this.mediaQueryList.matches;
  }

  chooseAjaxHelper(updateAll = false) {
    if (!updateAll && !this.isDesktop()) {
      this.obListHelper = this.updateFilterPanelAjax();
    } else {
      this.obListHelper = this.updateAllAjax();
      this.loadFilterPanelAjax();
    }

    this.instanceArray.forEach((el) => {
      el.obProductListHelper = this.obListHelper; // eslint-disable-line no-param-reassign
    });
  }

  updateAllAjax() {
    const obListHelper = new ShopaholicProductList();

    obListHelper.setAjaxRequestCallback((obRequestData) => {
      /* eslint-disable  no-param-reassign */
      obRequestData.update = {
        'product/catalog/catalog-ajax': `.${this.sCatalogWrapper}`,
        // eslint-disable-next-line sonarjs/no-duplicate-string
        'product/catalog/filter/filter-ajax': this.filterPanelWrapper,
      };
      obRequestData.complete = () => {
        LazyLoad.update();
        Select.checkSelect();
        if (!this.checkWindowPosition()) {
          const bar = $(this.filterBarSelector);

          if (!bar.length) return;

          const distance = bar.offset().top;

          $('body, html')
            .animate({ scrollTop: distance }, 350);
        }
      };
      obRequestData.loading = this.preLoaderSelector;
      /* eslint-enable */

      return obRequestData;
    });

    return obListHelper;
  }

  checkWindowPosition() {
    const docViewTop = $(window)
      .scrollTop();
    const docViewBottom = docViewTop + $(window)
      .height();
    const bar = $(this.filterBarSelector);

    if (!bar.length) return true;

    const elemTop = $(this.filterBarSelector)
      .offset().top;
    const elemBottom = elemTop + $(this.filterBarSelector)
      .height();

    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
  }

  updateFilterPanelAjax() {
    const obListHelper = new ShopaholicProductList();

    obListHelper.setAjaxRequestCallback((obRequestData) => {
      /* eslint-disable  no-param-reassign */
      obRequestData.update = {
        'product/catalog/filter/filter-ajax': this.filterPanelWrapper,
        'product/catalog/filter-bar/filter-bar-btn-ajax': this.filterBtnWrapperSelector,
      };
      obRequestData.loading = this.filterPreLoaderElector;
      /* eslint-enable */

      return obRequestData;
    });

    return obListHelper;
  }

  loadFilterPanelAjax() {
    $.request('onAjax', {
      update: {
        'product/catalog/filter/filter-ajax': this.filterPanelWrapper,
      },
      success(res) {
        this.success(res);
      },
    });
  }

  initFilterHandlers() {
    const obFilterPanel = new ShopaholicFilterPanel();
    obFilterPanel.init();

    const obBrandFilterPanel = new ShopaholicFilterPanel();
    obBrandFilterPanel
      .setWrapperSelector(this.brandWrapperSelector)
      .setFieldName('brand')
      .init();

    const obSaleFilterPanel = new ShopaholicFilterPanel();
    obSaleFilterPanel
      .setWrapperSelector(this.saleFilterWrapper)
      .setFieldName('sale')
      .init();

    const obNewFilterPanel = new ShopaholicFilterPanel();
    obNewFilterPanel.setWrapperSelector(this.newFilterWrapper)
      .setFieldName('new')
      .init();

    const obHitFilterPanel = new ShopaholicFilterPanel();
    obHitFilterPanel.setWrapperSelector(this.hitFilterWrapper)
      .setFieldName('hit')
      .init();

    const obDiscountFilterPanel = new ShopaholicFilterPanel();
    obDiscountFilterPanel.setWrapperSelector(this.discountFilerWrapper)
      .setFieldName('discount')
      .init();

    this.instanceArray = [
      obFilterPanel,
      obBrandFilterPanel,
      obSaleFilterPanel,
    ];
  }
}();
